var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('navigation',{attrs:{"authenticated":_vm.authenticated},on:{"logout":_vm.isAuthenticated}}),_c('div',{staticClass:"container mx-auto"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }